module.exports = __webpack_public_path__ + "img/share-blue.842bb8f5.svg";